<template>
  <div id="Occupation">
    <!-- Title -->
    <h1 v-bind="sectionTitleStyle" :style="sectionTitleStyle">Occupation</h1>
    <hr class="my-4" />

    <!-- Languages -->
    <b-row style="margin: 5% 20% 0% 20%;">
      <b-col class="domainBlock">
        <font-awesome-icon  :icon="['fas', 'laptop-code']" size="6x" />
          <br>
          <h4 :style="sectionSubtitleStyle">Web development</h4>
      </b-col>
      <b-col class="domainBlock">
        <font-awesome-icon  :icon="['fas', 'mobile-alt']" size="6x" />
          <br>
          <h4 :style="sectionSubtitleStyle">Mobile App development</h4>
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      sectionTitleStyle: {
        color: "#1a1a1a",
        class: "masthead-heading"
      },
      sectionSubtitleStyle: {
        center: true,
        color: "#1a1a1a",
        class: "masthead-heading"
      },
      icoDomain: {
          
        },
    };
  }
};
</script>